import { render } from "./Department.vue?vue&type=template&id=828125a4&scoped=true&ts=true"
import script from "./Department.vue?vue&type=script&lang=ts"
export * from "./Department.vue?vue&type=script&lang=ts"

import "./Department.vue?vue&type=style&index=0&id=828125a4&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-828125a4"]])

export default __exports__